import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-text-left" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12 p-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold p-mt-3" }, "ที่อยู่ในการจัดส่งสินค้า", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-mb-3 p-col-12 p-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold p-mt-3" }, "ที่อยู่ที่ใช้ในการออกใบเสร็จ", -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" เลขประจำตัวผู้เสียภาษี ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      header: "รายละเอียดที่อยู่",
      toggleable: true,
      collapsed: _ctx.isCollapsed,
      "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCollapsed) = $event))
    }, {
      icons: _withCtx(() => [
        _createElementVNode("span", {
          class: "text-gray-1 f-size-14",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
        }, "ดูรายละเอียด")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.userInfo.firstname) + " " + _toDisplayString(_ctx.buyerInfo.userInfo.lastname), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.userInfo.telephone), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.shippingAddress.address), 1),
                _createElementVNode("div", null, [
                  (_ctx.buyerInfo.shippingAddress.road)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "ถนน " + _toDisplayString(_ctx.buyerInfo.shippingAddress.road), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" แขวง/ตำบล " + _toDisplayString(_ctx.buyerInfo.shippingAddress.subdistrict) + " เขต/อำเภอ " + _toDisplayString(_ctx.buyerInfo.shippingAddress.district), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.shippingAddress.province) + " " + _toDisplayString(_ctx.buyerInfo.shippingAddress.zipcode), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.buyerInfo.billingAddress.firstname) + " " + _toDisplayString(_ctx.buyerInfo.billingAddress.lastname), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.userInfo.telephone), 1),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.billingAddress.address), 1),
                _createElementVNode("div", null, [
                  (_ctx.buyerInfo.billingAddress.road)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " ถนน " + _toDisplayString(_ctx.buyerInfo.billingAddress.road), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" แขวง/ตำบล " + _toDisplayString(_ctx.buyerInfo.billingAddress.subdistrict) + " เขต/อำเภอ " + _toDisplayString(_ctx.buyerInfo.billingAddress.district), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.buyerInfo.billingAddress.province) + " " + _toDisplayString(_ctx.buyerInfo.billingAddress.zipcode), 1),
                _createElementVNode("div", null, [
                  _hoisted_10,
                  (_ctx.buyerInfo.billingAddress.tax)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.buyerInfo.billingAddress.tax), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
}